import { render, staticRenderFns } from "./documentDetails.vue?vue&type=template&id=067fb2b4&scoped=true&"
import script from "./documentDetails.vue?vue&type=script&lang=js&"
export * from "./documentDetails.vue?vue&type=script&lang=js&"
import style0 from "./documentDetails.vue?vue&type=style&index=0&id=067fb2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067fb2b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('067fb2b4')) {
      api.createRecord('067fb2b4', component.options)
    } else {
      api.reload('067fb2b4', component.options)
    }
    module.hot.accept("./documentDetails.vue?vue&type=template&id=067fb2b4&scoped=true&", function () {
      api.rerender('067fb2b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/documents/documentDetails.vue"
export default component.exports